import type { Campaign, Product } from '@trmediaab/zebra-types/trhub';

function findCampaign(product: Product | undefined, campaigns: Campaign[]) {
  if (product == null) {
    return null;
  }

  return (
    campaigns.find(campaign =>
      campaign.products.some(
        campaignProduct => campaignProduct._id === product._id,
      ),
    ) || null
  );
}

interface ParsedProduct {
  headline: string;
  productHeadline: string;
  description: string;
  terms: string;
  price: number;
  reducedPrice: number | null;
  buttonText: string;
  campaign: Campaign | null;
}

const parseProduct = (product: Product, campaigns: Campaign[]) => {
  const campaign = findCampaign(product, campaigns);

  const parsed: ParsedProduct = {
    headline: campaign != null ? campaign.headline : product.headline,
    productHeadline: product.headline,
    description: campaign != null ? campaign.infoText : product.infoText,
    terms: campaign != null ? campaign.terms : product.paymentTerms,
    price:
      campaign != null && campaign.type === 'fixedPrice'
        ? product.price * campaign.duration
        : product.price,
    reducedPrice: campaign != null ? campaign.price : null,
    buttonText:
      campaign != null && campaign.buttonText.length > 0
        ? campaign.buttonText
        : product.buttonText.length > 0
          ? product.buttonText
          : `Välj ${product.headline}`,
    campaign,
  };

  return parsed;
};

export default parseProduct;
